export enum Tab {
  LOGIN = 'login',
  LOGOUT = 'logout',
  ACT_AS = 'act_as',

  // for user-portal
  MAP = 'map',
  ECO_DRIVING = 'eco-driving',
  DRIVERS = 'drivers',
  SENSORS = 'sensors',
  REPORT = 'report',
  CHART = 'chart',
  VEHICLE = 'vehicle',
  NOTIFICATION = 'notification',
  VIDEO = 'video',
  LOGISTIC = 'logistic',
  PUBLIC = 'public',
  TELEGRAM = 'telegram-chat/activation',
  ACCESS_DENIED = 'access-denied',
  ROUTES = 'routes',
  RUNS = 'runs',
  GEOFENCES = 'geofences',
  SEASON_CALENDAR = 'season-calendar',

  // for admin-portal
  MAIN='main',

  USERS = 'users',
  UNITS = 'units',
  TEMPLATES = 'templates',
  RETRANSLATORS = 'retranslators',
  BRAND = 'branding',
}
